var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayerData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21H26.3334C27.2538 21 28 20.2538 28 19.3333V19.3333C28 18.4493 27.6488 17.6014 27.0237 16.9763C26.3986 16.3512 25.5508 16 24.6667 16H17.3334",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4394 11.879C23.3389 11.879 24.8789 10.3391 24.8789 8.43949C24.8789 6.53991 23.3389 5 21.4394 5C19.5398 5 17.9999 6.53991 17.9999 8.43949C17.9999 10.3391 19.5398 11.879 21.4394 11.879Z",
    stroke: "#EC5341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2821 28C21.2026 28 21.9488 27.2538 21.9488 26.3333V25.6667C21.9488 24.429 21.4656 23.242 20.6056 22.3668C19.7456 21.4917 18.5791 21 17.3628 21H8.19084C6.97456 21 5.8081 21.4917 4.94806 22.3668C4.08802 23.242 3.60486 24.429 3.60486 25.6667V26.3333",
    stroke: "#626569",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7768 18.2931C15.3096 18.2931 17.3628 16.2398 17.3628 13.7071C17.3628 11.1743 15.3096 9.12109 12.7768 9.12109C10.244 9.12109 8.1908 11.1743 8.1908 13.7071C8.1908 16.2398 10.244 18.2931 12.7768 18.2931Z",
    stroke: "#EC5341",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerData);
export default __webpack_public_path__ + "static/media/player_data.aea47c67feac157cedf938a7fdf94eae.svg";
export { ForwardRef as ReactComponent };